import type * as React from 'react';
import type { ModelTab } from '../../views/model/modelTabs';
import { DashboardIcon, FlaskIcon, FolderIcon, InfoIcon, LockIcon, ModelsIcon, ToolboxIcon } from './navIcons';

// 🔴 THE OVERHAUL SHELL: TWO GLOBAL ROWS, Dashboard then Models. Nothing is stranded: Projects, Test
// Ground and Toolbox are the model level's links, and Analytics is what Dashboard renders.
export const NAV_ITEMS = [
  { id: 'analytics' as const, labelKey: 'nav:header.dashboard', Icon: DashboardIcon },
  { id: 'models' as const, labelKey: 'nav:header.models', Icon: ModelsIcon },
];

/** The model level's link icons, one per model tab. */
export const TAB_ICON: Record<ModelTab, React.ElementType> = {
  overview: InfoIcon,
  projects: FolderIcon,
  testground: FlaskIcon,
  toolbox: ToolboxIcon,
  access: LockIcon,
};
